import * as React from 'react'
import { connect } from 'react-redux'
import { PhoneSystemNumberCreateFormComponent } from './PhoneSystemNumberCreateForm'
import { reduxForm } from 'redux-form'
import { flow, get } from 'lodash'
import { SearchPhoneSystemDidNumbersQuery } from 'src/generated/graphql'

const formName = 'phoneSystemNumberCreate'

export interface INumberCreateFormData {
  phoneSystemId: string
  number: string
  customerReference: string
  flowId: string
  selectedNumbers?: SearchPhoneSystemDidNumbersQuery['searchPhoneSystemDIDNumbers']
}

export interface IPhoneSystemNumberCreateFormProps {
  onAfterSubmit: () => undefined
  initialValues?: INumberCreateFormData
  isNumberSelected?: boolean
}

const stateToProps = ({ form }) => ({
  isNumberSelected: get(form, [formName, 'values', 'selectedNumbers'], []).length == 1,
})

const dispatchToProps = {}

export const PhoneSystemNumberCreateForm = flow<any, any, React.SFC<IPhoneSystemNumberCreateFormProps>>(
  reduxForm({ form: formName }),
  connect(stateToProps, dispatchToProps)
)(PhoneSystemNumberCreateFormComponent)



// WEBPACK FOOTER //
// src/features/PhoneSystem/PhoneSystemNumberCreateForm/PhoneSystemNumberCreateForm.container.ts